export const RANGE_VALUE = 'range';
export const RANGE_TYPE = 'type';
export const PERCENT = 'percent';

export const DEFAULT_COLOR = '#f0f0f0';

/** 仪表盘由 指针和表盘 组成 */
export const INDICATEOR_VIEW_ID = 'indicator-view';
export const RANGE_VIEW_ID = 'range-view';
